import { render, staticRenderFns } from "./SalesProfitPanel.vue?vue&type=template&id=45449c94"
import script from "./SalesProfitPanel.vue?vue&type=script&lang=js"
export * from "./SalesProfitPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports